import logoCedeoBoost from '@public/cedeo-boost.png';
import miniLogoCedeoBoost from '@public/mini-cedeo-boost.png';

export default {
  'CEDEO BOOST': miniLogoCedeoBoost,
  'CEDEO BOOST RECAP': logoCedeoBoost
};
